import create from "zustand";
import { ProductType } from "./payment/checkout/paymentTypes";

interface InfoState {
    abo: any;
    setAbo: (abo: any) => void;

    aboBasic: ProductType;
    setAboBasic: (aboBasic) => void;

    aboDuo: ProductType,
    setAboDuo: (aboDuo) => void;

    aboFamily: ProductType,
    setAboFamily: (aboFamily) => void;

    abo6m: ProductType,
    setAbo6m: (abo6m) => void;
}

const useInfoState = create<InfoState>(
    (set, get) => (
        {
            abo: null,
            setAbo: (abo) => set({ abo }),

            aboBasic: null,
            setAboBasic: (aboBasic) => set({aboBasic}),

            aboDuo: null,
            setAboDuo: (aboDuo) => set({ aboDuo }),

            aboFamily: null,
            setAboFamily: (aboFamily) => set({aboFamily}),

            abo6m: null,
            setAbo6m: (abo6m) => set({abo6m})
        }
    )
);

export default useInfoState;
